import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import alert from "../assets/img/ALARM.svg";
import { useStores } from "../hooks/useStores";
import Alerts from "../components/Alerts";
import Notices from "../components/Notices";

const Notifications = observer(() => {
  const { t } = useTranslation();
  const { notificationStore, myTibStore } = useStores();
  const { notifications, alerts } = notificationStore;
  const { allLines, getAllLines, allStops, getAllStops } = myTibStore;
  const [modifiedAlerts, setModifiedAlerts] = useState([]);

  useEffect(() => {
    getAllLines(undefined, true);
    getAllStops();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (alerts && alerts.length && allLines && allLines.length && allStops && allStops.length) {
      const modAle = alerts.map((alert: any) => {
        const newAlertLines = alert.alertLines.map((line: number) => {
          let newLine: number = line;
          allLines.forEach((completeLine: any) => {
            if (completeLine.id === line) newLine = completeLine.cod;
          });

          return newLine;
        });

        const newStops = alert.alertStops.map((stop: number) => {
          let newStop: number | string = stop;
          allStops.forEach((completeStop: any) => {
            if (completeStop.id === stop) newStop = `${completeStop.nam} (${completeStop.cod})`;
          });

          return newStop;
        });
  
        return { ...alert, alertLines: newAlertLines, alertStops: newStops };
      });
  
      setModifiedAlerts(modAle as never);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allLines, alerts, allStops]);

  return (
    <div className="page" data-testid="notifications-test">
      <div className="page-title-mobile">
        {t("notifications").replace("/", " ")}
        <img src={alert} alt="img" />
      </div>
      <div className="favs-container">
        <Alerts alerts={modifiedAlerts} />
        <Notices notifications={notifications} allLines={allLines} />
      </div>
    </div>
  );
});

export default Notifications;
